import script from "./joinTeam.vue?vue&type=script&setup=true&lang=ts"
export * from "./joinTeam.vue?vue&type=script&setup=true&lang=ts"

import "./joinTeam.vue?vue&type=style&index=0&id=3c4cc533&lang=less"

const __exports__ = script;

export default __exports__